export default "__VITE_ASSET__BYcnHI2o__"